export const FETCH_BOOKINGS = 'bookings/fetchBookings'
export const ADD_BOOKING = 'bookings/addBooking'
